/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const NativeAuthStartResponse = zod
  .object({
    authMethod: zod.enum(['code', 'password']).optional(),
    channel: zod.enum(['email', 'phone']),
    csrfToken: zod.string(),
    expiresAt: zod.iso.datetime({ offset: true }),
    flowId: zod.string().min(1),
    flowKind: zod.enum(['login', 'registration', 'recovery']),
    homeRegion: zod
      .enum(['au', 'us'])
      .optional()
      .describe("One of OnEarly's regions: `au` (Australia) or `us` (United States)."),
    identifier: zod.string().min(1),
    registrationTraits: zod
      .object({
        email: zod.email(),
        name: zod.object({
          first: zod.string().min(1),
          last: zod.string().min(1),
        }),
        phone_number: zod.string().min(1),
      })
      .optional(),
    sessionTokenExchangeCode: zod.string().optional(),
  })
  .and(
    zod.object({
      homeRegionRequired: zod
        .boolean()
        .describe(
          'True when the identity being signed into has no home region yet: a new account, or an account an invitation created, at its first sign-in. The client then asks the person, even when only one region is open, and sends their choice as `homeRegion` on verify (or resend).',
        ),
    }),
  );

export type NativeAuthStartResponse = zod.input<typeof NativeAuthStartResponse>;
export type NativeAuthStartResponseOutput = zod.output<typeof NativeAuthStartResponse>;
